angular.module('lsnBase.filters')
  .filter('percentage', [function() {
    return function(value) {
      var stringValue = value ? value + '' : '0';
      return stringValue.replace('.', ',')+'%';
    };
  }]);